import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { DialogCookieConfirm } from '../dialog-cookie-confirm/dialog-cookie-confirm.component';
@Component({
  selector: 'app-dialog-info-abbilitazione-cookie',
  templateUrl: './dialog-info-abbilitazione-cookie.component.html',
  styleUrls: ['./dialog-info-abbilitazione-cookie.component.css']
})
export class DialogInfoAbbilitazioneCookieComponent {

  constructor(public dialogRef: MatDialogRef<DialogInfoAbbilitazioneCookieComponent>
    , private dialog: MatDialog) { }

  impostazioniCookies() {
    this.dialogRef.close();
    this.dialog.open(DialogCookieConfirm);
  }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-info-abbilitazione-cookie/dialog-info-abbilitazione-cookie.component.ts